var E = /* @__PURE__ */ ((r) => (r.PERCENTAGE = "percentage", r.ABSOLUTE = "fixed_value", r))(E || {}), e = /* @__PURE__ */ ((r) => (r.DOUBLE_BED = "double-bed", r.SIZE = "size", r.GUESTS = "guests", r.PROPERTY = "property", r))(e || {}), u = /* @__PURE__ */ ((r) => (r.VALID = "valid", r.ERROR = "error", r.DEFAULT = "default", r))(u || {});
export {
  E as DiscountType,
  u as FieldState,
  e as IconType
};
